import AnimateText from '@/components/AnimateText/AnimateText'
import Header from '@/components/Layout/Header'
import { PrivateRoutes, PublicRoutes } from '@/constants/routes'
import { IConfigSeller } from '@/models/configSeller'
import { IUser } from '@/models/user.model'
import { webApiService } from '@/services'
import { getMonto } from '@/utils/getMonto'
import { terms } from '@/utils/terms'
import { Button } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { MdArrowBack, MdArrowForward } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import StepOne from './components/StepOne'
import StepThree from './components/StepThree'
import StepTwo from './components/StepTwo'
import { initialStateFormularioClienteContext } from './context/FormularioClienteContext'
import { useFormularioClienteContext } from './hooks/useFormularioClienteContext'

const FormularioClientePage = () => {
  const { ctx, saveCtx } = useFormularioClienteContext()
  const [data, setData] = useState({ loading: false })
  const userState = useSelector((store: { user: IUser }) => store.user)
  const { slug } = useParams()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const navigate = useNavigate()
  const location = useLocation()

  let isInIframe = false

  try {
    isInIframe = window.self !== window.top
  } catch (e) {
    isInIframe = true // No se puede acceder a window.top, asumimos que está en iframe
  }

  const handleRestart = async () => {
    console.log('Volviendo a comenzar...')
    window.location.reload()
  }

  const getGrade = (monto: any) => {
    if (slug !== 'macstore' && slug !== 'samsung-rom' && slug !== 'conecta-peru' && slug !== 'samsung-mx') {
      return null
    } else if (ctx.data.sbu.id_sbu === 2 && slug === 'macstore') {
      return ctx.data.listMacbookGrades.find((ele: any) => ele.amountMacbook === monto).grade
    } else if (slug === 'samsung-mx') {
      return ctx.data.capacityModel.find((ele: any) => ele.amount === monto).grade
    } else {
      return ctx.data.capacityModel.find((ele: any) => ele.amount === monto && ele.capacity === ctx.data.capacity.capacity).grade
    }
  }

  const handleNext = async () => {
    if (ctx.steps.current < 2) {
      saveCtx({ ...ctx, steps: { isValid: false, current: ctx.steps.current + 1 } })
    } else {
      setData({ ...data, loading: true })
      const code = ctx.data.sbu.id_sbu === 1 || (ctx.data.sbu.id_sbu === 3 && ctx.data.brand.brand === 'Apple') ? await webApiService.createLoginCode().then(res => res.data) : null
      const monto = getMonto(ctx.data, String(slug))
      const grade = getGrade(monto)
      console.log('🚀 ~ handleNext ~ grade:', grade)
      const obj = {
        id_sbu: ctx.data.sbu.id_sbu,
        sbu: ctx.data.sbu.name,
        brand: ctx.data.brand.brand,
        model: ctx.data.model.model,
        capacity: ctx.data.capacity.capacity,
        cpu: ctx.data.cpu.name,
        cpu_generation: ctx.data.generation.cpu_generation,
        screen: ctx.data.screen.screen,
        ram: ctx.data.ram.ram,
        name: ctx.data.name,
        lastname: ctx.data.lastname,
        email: ctx.data.email,
        // discount_amount: (ctx.data.sbu.id_sbu === 2 && [1, 2].includes(ctx.data.brand.id_brand)) || (ctx.data.sbu.id_sbu !== 2 && ctx.data.capacity.id_capacity === 0) ? ctx.data.model.amount - resultado : ctx.data.capacity.amount - resultado,
        gpu: ctx.data.gpu.name,
        discount_amount: ctx.data.extraControls ? (Number(ctx.data.extraControls) * Number(import.meta.env.VITE_EXTRA_CONSOLA) + monto) : monto,
        answers: ctx.data.answers,
        login_code: code,
        seller: slug,
        id_store: ctx.data.id_store,
        id_user: userState.id,
        grade: grade,
        executive_name: ctx.data.executiveName === '' ? null : ctx.data.executiveName,
        executive_lastname: ctx.data.executiveLastname === '' ? null : ctx.data.executiveLastname,
        executive_rut: ctx.data.executiveRut === '' ? null : ctx.data.executiveRut,
        extra_controls: ctx.data.extraControls ?? null,
        isInIframe,
        campaign: ctx.data.campaign !== null ? ctx.data.campaign : null
      }

      console.log('obj =>', obj)

      await webApiService.save(obj).then(res => {
        console.log('🚀 ~ awaitwebApiService.saveData ~ res:', res)
        enqueueSnackbar('Sus datos fueron enviados. Revise su correo por favor...', { variant: 'success' })
        saveCtx(initialStateFormularioClienteContext)

        // solo para reuse
        if (slug === 'reuse' || slug === 'macstore') {
          const data = { id: res.data.insertId, discount: obj.discount_amount }
          window.parent.postMessage(data, '*')
        } else {
          if (location.pathname.includes('backoffice')) {
            navigate(PrivateRoutes.SUCCESS.replace(':slug', String(slug)))
          } else {
            navigate(PublicRoutes.SUCCESS.replace(':slug', String(slug)))
          }
        }
      }).catch(err => {
        enqueueSnackbar('No fue posible guardar la información del trade-in: ' + err, { variant: 'error' })
      }).finally(() => {
        setData({ ...data, loading: false })
      })
    }
  }

  const handleBack = () => {
    saveCtx({ ...ctx, steps: { isValid: true, current: ctx.steps.current - 1 } })
  }

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <StepOne />
      case 1:
        return <StepTwo />
      case 2:
        return <StepThree />
      default:
        return 'Redireccionando al agendamiento...'
    }
  }
  console.log('ctx =>', ctx)

  return (
    <div className='flex flex-col h-full min-h-screen'>
      {configSeller.config.s3.FOLDER_APP === 'ti_macstore' && userState.id !== 0 &&
        <Header />}
      <header className='py-4 container  max-w-[1100px] mb-4 mx-auto px-4 md:px-2'>
        {ctx.steps.current === 0 ? <AnimateText text='Elige tu equipo actual' className='text-4xl font-bold mb-5' /> : null}
        {ctx.steps.current === 1 ? <AnimateText text='Evalúa tu equipo' className='text-4xl font-bold mb-5' /> : null}
        {ctx.steps.current === 2 ? <AnimateText text='¡Casi listo! Ingresa tu email' className='text-4xl font-bold mb-5' /> : null}
      </header>
      <section className='container mx-auto max-w-[1100px] md:px-2'>
        <div className='grid grid-cols-3 gap-x-3 px-2 md:px-0'>
          <div className={ctx.steps.current >= 0 ? 'border-b-4 border-black' : 'border-b-4 border-gray-300'} />
          <div className={ctx.steps.current >= 1 ? 'border-b-4 border-black' : 'border-b-4 border-gray-300'} />
          <div className={ctx.steps.current >= 2 ? 'border-b-4 border-black' : 'border-b-4 border-gray-300'} />
        </div>
        {getStepContent(ctx.steps.current)}
      </section>
      <footer>
        <div className='container mx-auto text-center max-w-[1100px]'>
          <div className={ctx.steps.current > 0 ? 'flex justify-between' : 'w-auto inline-block'}>
            <Button
              className={ctx.steps.current === 2 ? 'rounded-md uppercase bg-gray-50 border-1 border-black me-2 hidden' : 'hidden'}
              onClick={handleRestart}
              isDisabled={data.loading}
            >
              Volver a empezar
            </Button>
            <Button startContent={<MdArrowBack />} isDisabled={ctx.steps.current === 0} onClick={handleBack} className={ctx.steps.current !== 0 ? 'rounded-full bg-gray-50 border-1 border-gray-50 py-6 px-10' : 'hidden'}>
              Paso anterior
            </Button>
            <div className={ctx.steps.current < 2 ? 'ms-2' : 'mt-2'}>
              <Button
                fullWidth
                className='rounded-full bg-black text-white disabled:bg-gray-300 disabled:border-gray-300 border-1 py-6 px-10'
                onClick={handleNext}
                size={ctx.steps.current === 2 ? 'lg' : undefined}
                isLoading={data.loading}
                endContent={<MdArrowForward />}
                isDisabled={
                  (ctx.steps.current < 2 && !ctx.steps.isValid) ||
                  (ctx.steps.current === 2 && ctx.data.email === '') ||
                  (ctx.steps.current === 2 && ctx.data.name === '') ||
                  (ctx.data.email !== '' && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(ctx.data.email)) ||
                  (configSeller.config.s3.FOLDER_APP === 'ti_coppel' && ctx.data.id_store === 0 && ctx.steps.current === 2) ||
                  (configSeller.config.s3.FOLDER_APP === 'ti_macstore' && ctx.steps.current === 2 && userState.id === 0 && (ctx.data.id_store === 0 || ctx.data.executiveName === '' || ctx.data.executiveLastname === '' || ctx.data.executiveRut === '') && !isInIframe) ||
                 // siguiente linea agregar validacion de option si es que tiene el campo requerido en true
                 (ctx.steps.current === 2 && configSeller.config.optin !== undefined && configSeller.config.optin.some(optin => optin.requerido && !ctx.data.optins.find(o => o.id === optin.id)?.checked)) ||
                 ((configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom' || configSeller.config.s3.FOLDER_APP === 'ti_falabella_pe' || configSeller.config.s3.FOLDER_APP === 'ti_motorola' || configSeller.config.s3.FOLDER_APP === 'ti_wom' || configSeller.config.s3.FOLDER_APP === 'ti_oppo') && ctx.steps.current === 2 && (ctx.data.executiveName === '' || ctx.data.executiveLastname === '' || ctx.data.executiveRut === '') && location.pathname.includes('backoffice')) ||
                (configSeller.config.s3.FOLDER_APP === 'ti_falabella' && ctx.steps.current === 1 && (ctx.data.brand.id_brand === 17 || ctx.data.brand.id_brand === 64) && Number(ctx.data.extraControls) > 3)
                }
              >
                {ctx.steps.current === 2 ? 'Finalizar' : 'Continuar'}
              </Button>
            </div>
          </div>

        </div>
      </footer>
      {configSeller.config.terms !== undefined &&
          configSeller.config.terms !== '' &&
          configSeller.config.s3.FOLDER_APP === 'ti_falabella' &&
          terms(configSeller.config.terms, true)}
    </div>
  )
}

export default FormularioClientePage
